import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { ClassReportStudent } from '../data/class-report';
import { ISortOrder } from '../sort-toggle/sort-toggle.component';
import { FormatUtilities } from '../utilities/format-utilities';
import { Course } from '../data/course';
import { StudentSpeakingScore } from '../data/speaking-score';

@Component({
  selector: 'app-class-students-report',
  templateUrl: './class-students-report.component.html',
  styleUrls: ['./class-students-report.component.css']
})
export class ClassStudentsReportComponent extends BaseComponent implements OnInit {

  displayTime = FormatUtilities.displayTimeWithoutSeconds;

  @Input() students: ClassReportStudent[];
  @Input() organizationId: number;
  @Input() classId: number;
  @Input() clickable: boolean;
  @Input() showScores: boolean = false;

  courses: Course[] = [];
  studentSpeakingScores: StudentSpeakingScore[] = [];

  ngOnInit() {
    this.dataService.getCourses().subscribe(c => this.courses = c);
    if (this.showScores) this.dataService.getClassSpeakingScores(this.classId).subscribe(s => this.studentSpeakingScores = s);
  }

  updateSort(sortOrder: ISortOrder) {
    this.students.sort((a, b) => {
      var sortVal =
        sortOrder.orderBy === 'LevelUnit' ? this.levelUnitSort(a, b) :
          sortOrder.orderBy === 'TimeInAllCourses' ? this.sortNumbers(a.TimeInAllCourses, b.TimeInAllCourses) :
            sortOrder.orderBy === 'LastLogin' ? this.loginSort(a, b) :
              sortOrder.orderBy === 'UnitTest' ? this.sortNumbers(this.getUnitTestPercent(a), this.getUnitTestPercent(b)) :
                sortOrder.orderBy === 'SpeakingOpportunities' ? this.sortNumbers(a.SpeakingOpportunities, b.SpeakingOpportunities) :
                  sortOrder.orderBy === 'SpeakingScore' ? this.sortSparcScore(a, b) :
                    this.sortString(a.StudentName, b.StudentName);
      if (!sortOrder.ascending) sortVal *= -1;
      return sortVal;
    });
  }

  levelUnitSort(a, b) {
    let aCourse = this.courses.find(course => course.Code == a.CurrentCourse);
    let aLevel = aCourse ? aCourse.NumberOnly : 0;
    let aUnit = (a.FurthestUnit || 0);

    let bCourse = this.courses.find(course => course.Code == b.CurrentCourse);
    let bLevel = bCourse ? bCourse.NumberOnly : 0;
    let bUnit = (b.FurthestUnit || 0);

    let courseSortResult = aLevel - bLevel;
    let unitSortResult = aUnit - bUnit;
    let finalResult = courseSortResult || unitSortResult;

    return finalResult;
  }

  loginSort(a, b) {
    let aLogin, bLogin;

    if (!a || !a.LastLogin) aLogin = 0;
    else aLogin = new Date(a.LastLogin).getTime();

    if (!b || !b.LastLogin) bLogin = 0;
    else bLogin = new Date(b.LastLogin).getTime();

    return aLogin - bLogin;
  }

  sortSparcScore(a: ClassReportStudent, b: ClassReportStudent) {
    var scoreDataA = this.getSpeakingScore(a);
    var scoreDataB = this.getSpeakingScore(b);
    var scoreA = (typeof scoreDataA !== 'undefined') ? scoreDataA.Score : -1;
    var scoreB = (typeof scoreDataB !== 'undefined') ? scoreDataB.Score : -1;
    return this.sortNumbers(scoreA, scoreB);
  }
  
  sortNumbers(numA, numB) {
    var cleanNumA = this.getUndefinedCheck(numA) ? -1 : numA;
    var cleanNumB = this.getUndefinedCheck(numB) ? -1 : numB;
    return cleanNumA - cleanNumB;
  }

  sortString(stringA, stringB) {
    var stringNameA = this.getUndefinedCheck(stringA) ? "" : stringA;
    var stringNameB = this.getUndefinedCheck(stringB) ? "" : stringB;
    return stringNameA.localeCompare(stringNameB);
  }

  getUndefinedCheck(value: number): boolean {
    return typeof value === 'undefined' || value === null;
  }

  getUndefinedCheckString(value: string): boolean {
    return value === "" || value === null || typeof value === 'undefined'
  }

  getSpeakingScore(student: ClassReportStudent): StudentSpeakingScore {
    if (!this.studentSpeakingScores || !this.studentSpeakingScores.length || this.studentSpeakingScores.length == 0) return null;
    return this.studentSpeakingScores.find(s => s.StudentID == student.StudentID);
  }

  getScoreImage(student: ClassReportStudent): string {
    let score = this.getSpeakingScore(student);
    if (!score) return "";
    let normalizedScore = score.NormalizedContextualScore;

    if (normalizedScore < 0.2) return "SPARC-dot-1.svg";
    else if (normalizedScore < 0.4) return "SPARC-dot-2.svg";
    else if (normalizedScore < 0.6) return "SPARC-dot-3.svg";
    else if (normalizedScore < 0.8) return "SPARC-dot-4.svg";
    else return "SPARC-dot-5.svg";
  }

  getCourseCodeAsLevel(courseCode: string): string {
    let course = this.courses.find(c => c.Code == courseCode);
    return FormatUtilities.getCourseNumberAsLevel(course?.NumberOnly);
  }

  getUnitTestPercent(report: ClassReportStudent): number {
    return this.roundPercent((report.UnitTestCorrect || 0) / (report.UnitTestTotal || 1));
  }

  getUnitText(unit: number): string {
    if (unit != null && unit !== 0) return `Unit ${unit}`;
    else return "not started";
  }

  roundPercent(rawPercent: number): number {
    return Math.round(rawPercent * 100);
  }

}
